import { useState, type FC } from 'react';
import { Textarea, Button } from '@g2u/ui-kit';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { type WithDataTest } from 'types';
import { type Rule } from 'antd/es/form';

type Props = {
  name: string;
  placeholder?: string;
  label: React.ReactNode;
  buttonText: string;
  maxCount?: number;
  rules?: Rule[];
  className?: string;
  initialValue?: string;
} & WithDataTest;

export const CollapsibleTextarea: FC<Props> = (props) => {
  const { dataTestId, name, placeholder, label, buttonText, maxCount, rules, className, initialValue } = props;
  const [isVisible, setIsVisible] = useState(!!initialValue);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div>
      {!isVisible && (
        <Button.$ dataTestId={`toggle-${dataTestId}-button`} onClick={toggleVisibility}>
          {!isVisible ? <PlusOutlined /> : <MinusOutlined />}
          {isVisible ? `Hide ${buttonText}` : `Add ${buttonText}`}
        </Button.$>
      )}
      {isVisible && (
        <Textarea.$
          dataTestId={dataTestId}
          name={name}
          placeholder={placeholder}
          initialValue={initialValue || ''}
          label={label}
          {...(maxCount && { count: { max: maxCount, show: true } })}
          rules={rules}
          className={className}
        />
      )}
    </div>
  );
};
